export default __webpack_public_path__ + "static/media/RightArrowWhite.3483d365.svg";